import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "absolute top-3 right-3 flex items-center gap-4" }
const _hoisted_2 = ["href"]

import { ArrowDownTrayIcon } from "@heroicons/vue/24/solid";
import { format, isValid } from "date-fns";
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import TimelapseVideoPlayer from "shared/components/camera/TimelapseVideoPlayer.vue";
import LogoWatermark from "shared/components/other/LogoWatermark.vue";
import { useCurrentCustomerName, useCurrentSiteId } from "shared/composables/project";
import { useFullWindow4to3RatioDimensionStyle } from "shared/composables/screen";
import CameraRepository from "shared/repositories/CameraRepository";
import PublicTokenRepository from "shared/repositories/PublicTokenRepository";
import logger from "shared/services/logger";
import { ProjectTimelapseResponse } from "shared/types/Camera";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectTimelapseView',
  setup(__props) {

const { t } = useI18n();

const loading = ref(false);
const timelapse = ref<ProjectTimelapseResponse>({
  presigned_url_timelapse: "",
  timestamps: [],
});
const noSrcMessage = ref<string | undefined>(undefined);

const currentCustomerName = useCurrentCustomerName();
const currentSiteId = useCurrentSiteId();
const route = useRoute();

const fullWindow4to3RatioDimensionStyle = useFullWindow4to3RatioDimensionStyle();

const formatMilestoneTime = (time: Date) => {
  return isValid(time) ? format(time, "dd.MM.yyyy HH:mm") : "";
};

onMounted(() => {
  loading.value = true;
  noSrcMessage.value = undefined;

  CameraRepository.loadProjectTimelapse(
    currentCustomerName,
    currentSiteId,
    route.params.camera_id as string,
  )
    .then((data) => {
      timelapse.value = data;
    })
    .catch((error) => {
      if (PublicTokenRepository.isPublicTokenAuthError(error)) {
        noSrcMessage.value = t("public_tokens.link_expired");
      } else {
        logger.error(error);
      }
    })
    .finally(() => {
      loading.value = false;
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(_unref(fullWindow4to3RatioDimensionStyle)),
    class: "relative"
  }, [
    _createVNode(TimelapseVideoPlayer, {
      autoPlay: "",
      keepControls: "",
      loading: loading.value,
      timestamps: timelapse.value.timestamps,
      src: timelapse.value.presigned_url_timelapse,
      noSrcMessage: _ctx.$t('err.no_data_yet'),
      formatTime: formatMilestoneTime
    }, null, 8, ["loading", "timestamps", "src", "noSrcMessage"]),
    _createElementVNode("div", _hoisted_1, [
      (!loading.value)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: timelapse.value.presigned_url_timelapse
          }, [
            _createVNode(_unref(ArrowDownTrayIcon), { class: "h-6 w-6 text-white hover:text-yellow-300" })
          ], 8, _hoisted_2))
        : _createCommentVNode("", true),
      _createVNode(LogoWatermark)
    ])
  ], 4))
}
}

})